import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import './bin-photo';
import '../props/bin-name';

class BinPhotoModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'bin-photo-modal';
  }

  static get properties() {
    return {
      photoHref: { type: String, attribute: false },
    };
  }

  renderContents() {
    return html`
      <style>
        bn-modal#bin-photo-modal {
          --modal-min-height: 50%;
          --modal-max-height: 95%;
          --modal-max-width: 95%;
        }
        #bin-photo-modal img {
          max-width: 100%;
          display: block;
          margin: auto;
        }
      </style>

      <h3 slot="title">Photo of <bin-name .href="${this.href}"></bin-name></h3>
      <img src="${this.photoHref}" />
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    const photos = this.entity && this.entity.getSubEntitiesByRel('https://api.binsentry.com/rel/bin-photo');
    this.photoHref = photos && photos.length > 0 && photos.pop().href;
  }
}

window.customElements.define('bin-photo-modal', BinPhotoModal);
